import React, { useEffect, useState } from "react";
import { Search, Calendar } from "lucide-react";
import NotFoundNotice from "../components/NotFound";
import TopNavbar from "../layouts/TopNavbar";
import MainLayout from "../layouts/MainLayout";
import FetchAllDownloadData from "../Services/Download/FetchDownloadData";
import Spinner from "../components/Spinner";
import { Link } from "react-router-dom";

const NoticeView = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]); // <-- changed from single to array
  const [isLoading, setIsLoading] = useState(false);
  const [downloads, setDownloads] = useState([]);

  // Fetch notices
  async function fetchDownloadData() {
    try {
      setIsLoading(true);
      const res = await FetchAllDownloadData();
      setDownloads(res.data);
      setIsLoading(false);
      console.log("download", res.data);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchDownloadData();
  }, []);

  // Get unique categories
  const uniqueCategories = [
    ...new Set(downloads.map((item) => item.category)),
  ].filter(Boolean);

  // Toggle category selection
  const toggleCategory = (category) => {
    const normalizedCategory = category.toLowerCase();
    if (selectedCategories.includes(normalizedCategory)) {
      // remove if already selected
      setSelectedCategories(
        selectedCategories.filter((c) => c !== normalizedCategory)
      );
    } else {
      // add new selection
      setSelectedCategories([...selectedCategories, normalizedCategory]);
    }
  };

  // Filtered notices
  const filteredNotices = downloads.filter((notice) => {
    const matchesSearch =
      notice?.name?.toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
      notice?.full_content
        ?.toLowerCase()
        .includes(searchTerm.trim().toLowerCase());

    const matchesCategory =
      selectedCategories.length === 0 ||
      selectedCategories.includes(notice?.category?.toLowerCase());

    return matchesSearch && matchesCategory;
  });

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCategories([]);
  };

  return (
    <>
      <TopNavbar />
      <MainLayout>
        <div className="lg:min-h-screen bg-yellow-50 mt-[100px] md:py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto py-1">
            {/* Header */}
            <div className="mb-8">
              <h1 className="text-4xl font-bold text-red-800 mb-2 mt-10 sm:mt-2">
                Download
              </h1>
              <p className="text-yellow-700">
                Stay updated with the latest announcements
              </p>
            </div>

            {/* Search & Categories */}
            <div className="bg-white rounded-xl min-w-[60%] shadow-lg p-4 border border-red-200 mb-6">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="w-full sm:max-w-[50%] relative flex-1">
                  <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-yellow-600 h-6 w-6" />
                  <input
                    type="text"
                    placeholder="Search notices..."
                    className="w-full pl-12 pr-4 py-3 border border-yellow-400 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all duration-300"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                {/* Category Buttons */}
                <div className="flex gap-2 overflow-x-auto pb-2">
                  {uniqueCategories.map((category) => (
                    <button
                      key={category}
                      className={`px-3 py-1 rounded-lg whitespace-nowrap transition-colors ${
                        selectedCategories.includes(category.toLowerCase())
                          ? "bg-red-600 text-white"
                          : "bg-yellow-200 text-red-700 hover:bg-yellow-300"
                      }`}
                      onClick={() => toggleCategory(category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Notices */}
            {isLoading ? (
              <div className="flex justify-center items-center py-20">
                <Spinner />
              </div>
            ) : filteredNotices.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 pb-10">
                {filteredNotices.map((notice) => (
                  <div
                    key={notice?.id}
                    className="bg-white rounded-xl shadow-lg p-6 border border-yellow-400 hover:shadow-xl transition-shadow"
                  >
                    <h3 className="text-lg font-semibold text-red-700 mb-2">
                      {notice?.name}
                    </h3>
                    <p
                      className="text-yellow-800 text-sm mb-3"
                      dangerouslySetInnerHTML={{ __html: notice?.full_content }}
                    ></p>

                    <div className="flex justify-between items-center text-sm text-yellow-700 mb-3">
                      <span className="flex items-center gap-1">
                        <Calendar className="h-4 w-4" />
                        {new Date(notice?.updated_at).toLocaleDateString()}
                      </span>
                    </div>

                    <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
                      <a
                        href={`https://admin.aspirationjeeneet.in/${notice?.pdf_uploaded}`}
                        className="w-full sm:w-auto text-center text-red-600 hover:underline bg-[#FFCC01] px-3 py-2 sm:px-4 sm:py-2 rounded-lg text-black text-sm sm:text-base"
                      >
                        Download PDF
                      </a>
                      <Link
                        to="/contact"
                        className="w-full sm:w-auto px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all duration-300 text-center"
                      >
                        Enquiry Now
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <NotFoundNotice resetFilters={resetFilters} />
            )}
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default NoticeView;
